interface ApplicationStepProps {
  description: string;
  number: number;
  title: string;
}

export const ApplicationStep = ({
  number,
  title,
  description,
}: ApplicationStepProps) => {
  return (
    <div className="relative h-full rounded-lg border bg-white px-4 pb-6 pt-6 lg:rounded-md lg:p-4 lg:px-8 lg:pb-12 lg:pt-14">
      <span className="absolute -top-4 left-4 flex aspect-square w-8 items-center justify-center rounded-full bg-yellow text-sm font-semibold text-black lg:left-8 lg:top-[-30px] lg:w-[60px] lg:text-lg">
        {number}
      </span>
      <h5
        className="!leading-snug"
        dangerouslySetInnerHTML={{ __html: title }}
      ></h5>
      <hr className="my-3 lg:my-6" />
      <div className="text-sm text-black-300">{description}</div>
    </div>
  );
};
